import { useEffect } from "react";

export function useEffectAsync(callback, deps) {
    useEffect(() => {
        callback()
    }, deps)
}